import React from "react";
import Header from "../../../components/Header";
import InventoryStockRequestsTable from "../../../tables/Inventory/InventoryStockRequestsTable";
import { useParams, useLocation } from "react-router-dom";
import GoBack from "../../../components/GoBack";

const InventoryStockRequests = () => {
  const { id: productId } = useParams();
  const { search } = useLocation();
  const variantId = new URLSearchParams(search).get("variant"); // This gets ?variant=...

  console.log("Product ID:", productId);
  console.log("Variant ID:", variantId);

  return (
    <div className="min-h-screen bg-[#F6F7F6]">
      <div className="mb-2">
        {" "}
        <GoBack />
      </div>
      <Header text="Stock Requests" />
      <div className="mt-6">
        <InventoryStockRequestsTable
          productId={productId}
          variantId={variantId}
        />
      </div>
    </div>
  );
};

export default InventoryStockRequests;
